module.exports = __webpack_public_path__ + "img/pool_liquility.9294204f.svg";